import { render, staticRenderFns } from "./StarInput.vue?vue&type=template&id=96a805a4&scoped=true"
import script from "./StarInput.vue?vue&type=script&lang=js"
export * from "./StarInput.vue?vue&type=script&lang=js"
import style0 from "./StarInput.vue?vue&type=style&index=0&id=96a805a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a805a4",
  null
  
)

export default component.exports